var map = {
	"./btn-add-bg.jpg": 1425,
	"./btn-add-icon.png": 76268,
	"./howWork-1.jpg": 75968,
	"./howWork.png": 95448,
	"./index-head-bg-h5.jpg": 66392,
	"./index-head-bg.jpg": 80377,
	"./logo.png": 52989,
	"./marspump.png": 60346,
	"./monpop-logo.svg": 72218,
	"./referral-total-1.png": 5058,
	"./referral-total-2.png": 36460,
	"./referral-total-bg1.jpg": 54357,
	"./referral-total-bg2.jpg": 41258,
	"./reward/mining-q-1.jpg": 10472,
	"./reward/mining-q-1.png": 56768,
	"./reward/mining-q-2.png": 14839,
	"./reward/mining-q-3.png": 29656,
	"./reward/mining-q-4.png": 10907,
	"./reward/mining-q-5.png": 77833,
	"./tab-icon-1.png": 21752,
	"./tab-icon-2.png": 95959,
	"./tab-icon-3.png": 31446,
	"./tab-icon-4.png": 60315
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70849;